/**
 * Stories for 404 handle this
 */
/* eslint-disable local-rules/require-storybook-documentation */

import { SVGProps } from 'react';
import { css } from '@/styled-system/css';

export const StairsBackground = ({ children, ...rest }: SVGProps<SVGSVGElement>) => (
    <svg
        className={css({
            display: {
                base: 'none',
                lg: 'block',
            },
            position: {
                lg: 'absolute',
            },
            width: {
                lg: '100%',
            },
            zIndex: 1,
        })}
        {...rest}>
        {children}
    </svg>
);
